module.exports = "<a [href]=\"websiteUrl\" target=\"_blank\" class=\"logo-container\">\n  <alg-logo></alg-logo>\n</a>\n<div class=\"cancel-button-container\">\n  <!-- <alg-button\n    outline=\"true\"\n    variant=\"tertiary\"\n    (click)=\"restartOnboarding()\">\n    <span  l10nTranslate>DELETE_ALL</span>\n  </alg-button> -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/alg-attivazioni/alg-attivazioni-header/alg-attivazioni-header.component.html
// module id = ./src/app/components/alg-attivazioni/alg-attivazioni-header/alg-attivazioni-header.component.html
// module chunks = main